export const FacebookIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z" fill="#3778EA"/>
      <path d="M16.2682 13.5093H13.9485V22.0076H10.434V13.5093H8.76245V10.5227H10.434V8.58998C10.434 7.2079 11.0905 5.0437 13.9798 5.0437L16.5831 5.05459V7.95363H14.6942C14.3844 7.95363 13.9487 8.10843 13.9487 8.76772V10.5254H16.5752L16.2682 13.5093Z" fill="white"/>
    </svg>
  )
}